import MuiSwitch from './muiSwitch'
export default MuiSwitch
